import PropTypes from "prop-types";

function DateCreatedCell({ dateCreated, ...restProps }) {
  const lastLoginDate = new Date(dateCreated).toLocaleString("en-US", {
    month: "numeric",
    day: "numeric",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });

  return (
    <div role="button" className="text-center" {...restProps}>
      <p
        className="
          text-sm
          font-bold
          capitalize
          tablet-sm:text-xs
        "
      ></p>
      {dateCreated && (
        <p className="text-xs font-bold text-gray-500">{lastLoginDate}</p>
      )}
    </div>
  );
}

DateCreatedCell.propTypes = {
  student: PropTypes.shape(),
};

export default DateCreatedCell;
